<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/rd5dpO/tc-custom/9781667450179.jpg?1682168953747" alt="This image is the cover for the book Arthyl, el Avatar de Eloïr"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Arthyl, el Avatar de Eloïr
      </h1>
      <p class="bookDescription body article font2">
        <p>Han pasado dos temporadas desde que Iriel acogió a Kalaen y este ha empezado a asentarse en su nueva vida. La herborista le pide que vaya a Tyrjanvil a entregar un paquete a Paludín. El anciano fue una vez mentor de Iriel en la hermandad druídica y mantenían una relación especial. ¿La intención de Iriel es sólo conseguir una comisión o tiene otras intenciones? Kalaen pronto lo descubrirá... y se sorprenderá.<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cédric Frantz, Paz Gil
      </h2>
      
      <p class="authorDescription body article">Cédric Frantz sólo es otra persona más apasionada por las palabras y la música.<br/></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Babelcube Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?25697d87